<template>
  <a-drawer
    :maskClosable="false"
    width="50%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onCloseConfirm(() => (open = false))"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" width="50%" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="文章标题" prop="title">
        <a-input v-model="form.title" placeholder="请输入文章标题" :maxLength="255" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="文章短标题" prop="shortTitle">
        <a-input v-model="form.shortTitle" placeholder="请输入文章短标题" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="文章分类" prop="classId">
        <a-select v-model="form.classId" placeholder="请选择文章分类" style="width: 100%" allow-clear>
          <a-select-option v-for="item in classList" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="文章作者" prop="author">
        <a-input v-model="form.author" placeholder="请输入文章作者" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="文章标题图片" prop="image">
        <file-upload
          type="image"
          @input="getImg($event, 'image')"
          :file="form.image"
          :count="1"
          :isUpload="false"
          pathSrc="article/image/"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="推荐" prop="recommend">
        <a-radio-group v-model="form.recommend" button-style="solid">
          <a-radio-button :value="1">是</a-radio-button>
          <a-radio-button :value="0">否</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="文章排序" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="255" placeholder="请输入排序值" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="文章正文" prop="content">
        <wang-editor-v5 v-model="form.content" v-if="open" :height="600" />
      </a-form-model-item>
      <a-form-model-item label="文章附件" prop="attachmentPath">
        <a-upload
          :disabled="isUploading"
          :file-list="attachmentFileList"
          :maxCount="1"
          :customRequest="customAttachmentRequest"
          @change="handleAttachmentChange"
          accept="video/*,.mp4,.avi,.mov,.wmv,.flv,.mkv,.webm,.m4v,.3gp"
        >
          <a-button :loading="isUploading"> <a-icon type="upload" />上传视频附件 </a-button>
        </a-upload>
        <div style="color: #999; font-size: 12px; margin-top: 4px">支持 MP4、AVI、MOV、WMV、FLV、MKV 等视频格式</div>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { addArticle, editArticle, getArticle } from '@/api/tutorial/article'
import { listArticleType } from '@/api/tutorial/articleType'
import WangEditorV5 from '@/components/Editor/WangEditorV5'
import { ossSignature } from '@/api/system/user'
import COS from 'cos-js-sdk-v5'
import moment from 'moment'

export default {
  name: 'CreateForm',
  components: {
    WangEditorV5,
  },
  data() {
    return {
      open: false,
      submitLoading: false,
      showLoading: false,
      formTitle: '新增文章',
      form: {
        id: undefined,
        title: '',
        shortTitle: '',
        classId: undefined,
        author: '',
        content: '',
        image: '',
        recommend: 0,
        sort: 0,
        attachmentPath: '',
      },
      classList: [],
      attachmentFileList: [],
      isUploading: false,
      rules: {
        title: [{ required: true, message: '文章标题不能为空', trigger: 'blur' }],
        classId: [{ required: true, message: '请选择文章分类', trigger: 'change' }],
        author: [{ required: true, message: '文章作者不能为空', trigger: 'blur' }],
        recommend: [{ required: true, message: '请选择推荐状态', trigger: 'change' }],
      },
    }
  },
  methods: {
    handleAdd() {
      this.reset()
      this.formTitle = '新增文章'
      this.open = true
    },
    reset() {
      this.form = {
        id: undefined,
        title: '',
        shortTitle: '',
        classId: undefined,
        author: '',
        content: '',
        image: '',
        recommend: 0,
        sort: 0,
        attachmentPath: '',
      }
      this.attachmentFileList = []
      this.$refs.form && this.$refs.form.clearValidate()
    },
    getClassList() {
      listArticleType().then((res) => {
        this.classList = res.data || []
      })
    },
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      if (!id) {
        this.$message.error('缺少必要参数')
        return
      }
      if (row && row.status === 2) {
        this.$message.warning('已发布的文章不能修改', 3)
        return
      }
      this.formTitle = '编辑文章'
      getArticle(id)
        .then((response) => {
          if (response.code === '20001' || response.success) {
            const data = response.data || {}
            this.form = {
              id: data.id,
              title: data.title || '',
              shortTitle: data.shortTitle || '',
              classId: data.classId,
              author: data.author || '',
              content: data.content || '',
              image: data.image || '',
              recommend: data.recommend !== undefined ? data.recommend : 0,
              sort: data.sort || 0,
              attachmentPath: data.attachmentPath || '',
            }
            if (data.attachmentPath) {
              const fileName = data.attachmentPath.split('/').pop()
              this.attachmentFileList = [
                {
                  uid: Date.now() + '',
                  name: fileName,
                  status: 'done',
                  url: this.$url + data.attachmentPath,
                },
              ]
            }
            this.open = true
          } else {
            this.$message.error(response.message || '获取文章详情失败')
          }
        })
        .catch(() => {
          this.$message.error('获取文章详情失败')
        })
    },
    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    generateCosKey(name, ext) {
      var ymd = moment().format('YYYYMMDD_HHmmss_')
      var r = ('000000' + Math.random() * 1000000).slice(-6)
      var cosKey = name + `file_${ymd}_${r}.${ext}`
      return cosKey
    },
    handleAttachmentChange(info) {
      if (info.file.status === 'removed') {
        this.attachmentFileList = []
        this.form.attachmentPath = ''
        return
      }
      this.attachmentFileList = info.fileList
    },
    customAttachmentRequest(options) {
      const that = this
      this.isUploading = true
      const { file } = options
      this.attachmentFileList = [file]
      var lastIndex = file.name.lastIndexOf('.')
      var extName = lastIndex > -1 ? file.name.slice(lastIndex + 1) : ''
      const cosKey = this.generateCosKey('article/attachment/', extName)
      ossSignature()
        .then((res) => {
          res = res.data
          const cos = new COS({
            SecretId: res.tmpSecretId,
            SecretKey: res.tmpSecretKey,
            SecurityToken: res.sessionToken,
            StartTime: res.startTime,
            ExpiredTime: res.expiredTime,
          })
          cos.putObject(
            {
              Bucket: this.$Bucket,
              Region: 'ap-beijing',
              Key: cosKey,
              Body: file,
              SliceSize: 1024 * 1024 * 5,
              onProgress: function (progressData) {},
            },
            function (err, data) {
              if (err) {
                console.log('上传失败', err)
                options.onError(err)
                that.isUploading = false
              } else {
                that.form.attachmentPath = cosKey
                that.attachmentFileList = [
                  {
                    uid: file.uid,
                    name: file.name,
                    status: 'done',
                    url: that.$url + cosKey,
                  },
                ]
                options.onSuccess({
                  url: cosKey,
                })
                that.isUploading = false
              }
            }
          )
        })
        .catch((error) => {
          options.onError(error)
          this.isUploading = false
        })
    },
    onCloseConfirm(callback) {
      const that = this
      this.$confirm({
        title: '是否确认关闭？未保存的数据将丢失',
        onOk() {
          callback && callback()
          that.reset()
        },
        onCancel() {},
      })
    },
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
    submitForm() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          const submitData = {
            title: this.form.title,
            shortTitle: this.form.shortTitle || '',
            classId: this.form.classId,
            author: this.form.author || '',
            content: this.form.content,
            image: this.form.image || '',
            recommend: this.form.recommend,
            sort: this.form.sort || 0,
            attachmentPath: this.form.attachmentPath || '',
          }
          const isEdit = this.form.id !== undefined
          if (isEdit) {
            submitData.id = this.form.id
          }
          const apiCall = isEdit ? editArticle(submitData) : addArticle(submitData)
          apiCall
            .then((response) => {
              if (response.code === '20001' || response.success) {
                this.$message.success(isEdit ? '编辑成功' : '新增成功', 3)
                this.open = false
                this.reset()
                this.$emit('ok')
              } else {
                const messages = Object.values(object || {}).flatMap((errorArray) =>
                  errorArray.map((item) => item.message)
                )
                this.showLoading = true
                this.$nextTick(() => {
                  this.$refs.LoadingPop &&
                    this.$refs.LoadingPop.init(2, messages || [response.message || (isEdit ? '编辑失败' : '新增失败')])
                })
              }
            })
            .catch(() => {
              this.$message.error(isEdit ? '编辑失败' : '新增失败')
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop && this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
  created() {
    this.getClassList()
  },
}
</script>
<style scoped>
.bottom-control {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
